import styled from 'styled-components';

const BORDER_COLOR = '#d8dcdf';
const BORDER_WIDTH = '1px';
const OPEN_BORDER_COLOR = '#929ca6';

export function ifStyle(condition, trueStyle, falseStyle = '') {
  return condition ? trueStyle : falseStyle;
}

export const Container = styled.div`
  border-radius: 4px;
  position: relative;
  overflow: ${({ showToolTip }) => (showToolTip ? 'visible' : 'hidden')};
  display: flex;
  background: white;
  padding-right: 4px;

  border: ${BORDER_WIDTH} solid
    ${({ isOpen }) => (isOpen ? OPEN_BORDER_COLOR : BORDER_COLOR)};

  border-bottom: ${({ isOpen }) =>
    isOpen ? 'none' : `${BORDER_WIDTH} solid ${BORDER_COLOR}`};

  ${({ isOpen }) => {
    return isOpen
      ? {
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
        }
      : {};
  }};
`;

export const Input = styled.input`
  background: white;
  border: none !important;
  margin-bottom: 0 !important;
  display: flex;
`;

export const OptionsList = styled.div`
  max-height: 300px;
  overflow-y: auto;
  border: ${BORDER_WIDTH} solid ${OPEN_BORDER_COLOR};
  border-top: ${BORDER_WIDTH} solid ${BORDER_COLOR};
  position: absolute;
  z-index: 1;
  width: 100%;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  background: white;
`;

export const Item = styled.div`
  padding: 8px 16px;
  border-bottom: 1px solid #d8dcdf;
  font-size: 14px;
  cursor: pointer;

  transition: background 150ms ease-in-out;

  background: ${({ isHighlighted, isSelected }) => {
    if (isHighlighted) return '#e6e8eb';

    if (isSelected) return 'rgba(88, 193, 239, 0.25)';

    return 'white;';
  }};

  &:last-child {
    border: none;
  }
`;

export const DropDownButton = styled.button`
  background: none;
  padding: 0;
  border: 0;
  color: #9e9e9e;
  transition: all 150ms ease-in-out;

  &:hover {
    background: none;
    color: #142334;
  }

  &:focus {
    background: none;
    outline: none;
    color: #142334;
  }
`;

const rotate = (isOpen) => {
  const deg = isOpen ? 180 : 0;

  return `rotate(${deg}deg)`;
};

export const MenuButton = styled(DropDownButton)`
  transform: ${({ isOpen }) => rotate(isOpen)};
`;

export const OptionListText = styled.div`
  display: flex;
  padding: 8px 16px;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #142334;
`;
